import React from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { Badge, Card, Tooltip } from "antd";
import { formatDate } from "../../../Components/Common/FormatDate/FormatDate";
import bell from "../../../assets/images/bell.svg";
import { FaRegTimesCircle } from "react-icons/fa";
import '../utils/style.css';

const DetailNotification = ({ modal, toggle, selectedNotification }) => {

  const { title, type, message, createdAt } = selectedNotification || {};
  const emitter = selectedNotification?.emitter || {};
  console.log('selectedNotification', selectedNotification)

  const formattedDate = formatDate(createdAt);

  return (
    <Modal 
      isOpen={modal} 
      toggle={toggle} 
      centered 
      backdrop="static" 
      size="lg" 
      style={{ borderRadius: "10px", maxWidth: "500px",
        position: "fixed",
        right: 0,
        top: "50%",
        transform: "translateY(-50%)" }}
    >
      <ModalHeader 
        className="bg-info-subtle p-3" 
        toggle={toggle} 
        style={{ borderTopLeftRadius: "10px", borderTopRightRadius: "10px" }}
      >
        <img 
          src={bell} 
          className="img-fluid custom-image-size" 
          style={{ maxWidth: "30px", marginRight: "10px" }} 
        />
        <strong>Détail de la notification</strong>
      </ModalHeader>
      <ModalBody style={{ padding: "2rem 2rem", backgroundColor: "#f9f9f9" }}>
          <div className="mb-4">
            <p style={{ fontSize: "1.1rem"}}>
              <strong>Titre </strong>: {title || "-"}
            </p>
            <p style={{ fontSize: "1rem" }}>
              <strong>Message </strong>: {message || "-"}
            </p>
          </div>

          <div className="mb-4">
            <p style={{ fontSize: "1rem" }}>
              <strong>Type </strong>: {type || "-"}
            </p>
          </div>

          <div className="mb-4">
            <p style={{ fontSize: "1rem" }}>
              <strong>Créée le </strong>: {formattedDate}
            </p>
          </div>

          {emitter && (
            <div className="mb-4">
              <p style={{ fontSize: "1rem" }}>
                <strong>Fait par </strong> : {emitter?.name || "-"}
              </p>
              <p style={{ fontSize: "1rem" }}>
                <strong> Email </strong> : {emitter?.email || "-"}
              </p>
            </div>
          )}
      </ModalBody>
      <ModalFooter style={{ borderBottomLeftRadius: "10px", borderBottomRightRadius: "10px" }}>
        <div className="d-flex justify-content-end w-100">
          <Tooltip title="Fermer la notification" placement="top">
            <button 
              className="bg-info-subtle btn btn-light btn-sm" 
              onClick={toggle} 
              style={{ 
                display: "flex", 
                alignItems: "center", 
                gap: "10px", 
                backgroundColor: "#35ddb3ff", 
                color: "#000000ff", 
                borderRadius: "20px" 
              }}
            >
              <FaRegTimesCircle /> Fermer
            </button>
          </Tooltip>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default DetailNotification;
